function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

/**
 * A controller which prevents the virtual keyboard from showing up on mobile devices
 * when the field's overlay is closed.
 */
export var VirtualKeyboardController = /*#__PURE__*/function () {
  /**
   * @param {{ inputElement?: HTMLElement; opened: boolean } & HTMLElement} host
   */
  function VirtualKeyboardController(host) {
    var _this = this;

    _classCallCheck(this, VirtualKeyboardController);

    this.host = host;
    host.addEventListener('opened-changed', function () {
      if (!host.opened) {
        // Prevent opening the virtual keyboard when the input gets re-focused on dropdown close
        _this.__setVirtualKeyboardEnabled(false);
      }
    }); // Re-enable virtual keyboard on blur, so it gets opened when the field is focused again

    host.addEventListener('blur', function () {
      return _this.__setVirtualKeyboardEnabled(true);
    }); // Re-enable the virtual keyboard whenever the field is touched

    host.addEventListener('touchstart', function () {
      return _this.__setVirtualKeyboardEnabled(true);
    });
  }
  /** @private */


  _createClass(VirtualKeyboardController, [{
    key: "__setVirtualKeyboardEnabled",
    value: function __setVirtualKeyboardEnabled(value) {
      if (this.host.inputElement) {
        this.host.inputElement.inputMode = value ? '' : 'none';
      }
    }
  }]);

  return VirtualKeyboardController;
}();